import React, { useRef } from 'react';
import { Box, IconButton, Typography, ImageList, ImageListItem, ImageListItemBar } from '@mui/material';
import { AddAPhoto, Delete } from '@mui/icons-material';

export default function PhotoCapture({ photos, onChange, maxPhotos = 5, label = 'Foto' }) {
  const inputRef = useRef(null);

  const handleCapture = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const newPhotos = files.slice(0, maxPhotos - photos.length).map(file => ({
      file,
      preview: URL.createObjectURL(file),
      name: file.name
    }));

    onChange([...photos, ...newPhotos]);
    e.target.value = '';
  };

  const handleRemove = (index) => {
    const updated = [...photos];
    if (updated[index].preview) URL.revokeObjectURL(updated[index].preview);
    updated.splice(index, 1);
    onChange(updated);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="body2" color="text.secondary">{label}</Typography>
        {photos.length < maxPhotos && (
          <IconButton
            size="small"
            color="primary"
            onClick={() => inputRef.current?.click()}
          >
            <AddAPhoto />
          </IconButton>
        )}
      </Box>

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        multiple
        onChange={handleCapture}
        style={{ display: 'none' }}
      />

      {photos.length > 0 && (
        <ImageList cols={3} gap={4} sx={{ mt: 0 }}>
          {photos.map((photo, idx) => (
            <ImageListItem key={idx} sx={{ borderRadius: 1, overflow: 'hidden' }}>
              <img
                src={photo.preview || photo.url}
                alt={photo.name || `Foto ${idx + 1}`}
                style={{ height: 80, objectFit: 'cover' }}
              />
              <ImageListItemBar
                actionIcon={
                  <IconButton size="small" sx={{ color: 'white' }} onClick={() => handleRemove(idx)}>
                    <Delete fontSize="small" />
                  </IconButton>
                }
                sx={{ background: 'rgba(0,0,0,0.4)', height: 32 }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      )}
    </Box>
  );
}
